<template>
  <div v-if="items.length > 0" class="dashboard-panel print-break-inside-avoid">
    <h3 class="section-title mb-4">
      <svg class="w-5 h-5 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      Unscheduled Workstreams
      <span class="ml-2 text-sm font-normal text-gray-500">({{ items.length }})</span>
    </h3>
    <p class="text-sm text-gray-500 mb-3">
      Workstreams with missing planned start or finish dates.
    </p>
    <div class="overflow-x-auto">
      <table class="w-full text-sm text-left">
        <thead class="table-header">
          <tr>
            <th class="px-3 py-2">Development</th>
            <th class="px-3 py-2">Workstream</th>
            <th class="px-3 py-2">Owner</th>
            <th class="px-3 py-2">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="`${item.development}-${item.workstream}`"
            class="border-b border-gray-100 hover:bg-gray-50"
          >
            <td class="px-3 py-2 font-medium">{{ item.development }}</td>
            <td class="px-3 py-2">{{ item.workstream }}</td>
            <td class="px-3 py-2">{{ item.owner || '-' }}</td>
            <td class="px-3 py-2">
              <span class="px-2 py-1 rounded text-xs font-semibold" :class="statusBadge(item.status)">
                {{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  items: { type: Array, default: () => [] }
})

const statusBadge = (status) => {
  switch (status) {
    case 'On Track': return 'bg-green-100 text-green-800'
    case 'At Risk': return 'bg-yellow-100 text-yellow-800'
    case 'Delayed': return 'bg-red-100 text-red-800'
    default: return 'bg-gray-100 text-gray-800'
  }
}
</script>
